// 中煤能源
import Overview from './overview.vue';

export const componentMap = {
    overview: Overview
};
